module.exports = __webpack_public_path__ + "static/media/14b-01-HOME-insolada.19a2bb3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14b/14b-01-HOME-insolada.jpg
// module id = 149
// module chunks = 0